<div class="modal-header" id="changelog-modal-title">
    <h3 class="modal-title" translate="CHANGELOG_HEADER"></h3>
    <span class="close" (click)="modalInstance.hide()">&times;</span>
</div>
<div class="modal-body" id="modal-body">
    @if (changelogs.length) {
        <lib-changelog [changelogs]="changelogs" [changelogConfig]="changelogConfig"></lib-changelog>
    }
</div>
